import { useUserSecurityQuestionsQuery } from "../../../../../../api/user/useUserSecurityQuestionsQuery";
import { uiNotification } from "../../../../../../services/UINotificationService";

export function useQuestions() {
  const { data, isLoading } = useUserSecurityQuestionsQuery({
    onError: () => {
      uiNotification.error(
        "Unable to fetch security questions. Try again later.",
      );
    },
  });

  const options =
    data?.map((q) => ({
      label: q.question,
      value: q.id,
    })) || [];

  const getOptionById = (id) => options.find((o) => o.value === id) || null;

  return {
    isLoading,
    options,
    getOptionById,
  };
}
